<sm-title-bar pageTitle="Query Details" [back]="true"></sm-title-bar>

<div
  class="member_details_view"
  *ngIf="!loader && serviceQueryDetail.length > 0"
>
  <div class="container">
    <div class="row">
      <div class="col-sm-8 mobile-pnloyet">
        <div class="salon_mei_section">
          <mat-card appearance="outlined">
            <div class="exert_opd">
              <div class="opert_section">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                  class="more-button"
                  aria-label="More options"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button
                    mat-menu-item
                    (click)="addReply(serviceQueryDetail[0])"
                  >
                    <mat-icon class="material-icons-outlined">reply</mat-icon>
                    <span>Reply</span>
                  </button>
                  <button
                  *ngIf="serviceQueryDetail[0].status != 1"
                    mat-menu-item
                    (click)="changeRequestStatus(serviceQueryDetail[0], 1)"
                  >
                    <mat-icon class="material-icons-outlined">grade</mat-icon>
                    <span>Mark as new</span>
                  </button>
                  <button
                  *ngIf="serviceQueryDetail[0].status != 2"
                    mat-menu-item
                    (click)="changeRequestStatus(serviceQueryDetail[0], 2)"
                  >
                    <mat-icon class="material-icons-outlined"
                      >hourglass_top</mat-icon
                    >
                    <span>Mark as in-progress</span>
                  </button>
                  <button
                  *ngIf="serviceQueryDetail[0].status != 3"
                    mat-menu-item
                    (click)="changeRequestStatus(serviceQueryDetail[0], 3)"
                  >
                    <mat-icon class="material-icons-outlined"
                      >task_alt</mat-icon
                    >
                    <span>Mark as resolved</span>
                  </button>
                  <!-- <button mat-menu-item (click)="changeRequestStatus(serviceQueryDetail[0],4)" *ngIf="serviceQueryDetail[0].enrollment_request_status != 4 &&  serviceQueryDetail[0].enrollment_request_status != 5">
         <mat-icon class="material-icons-outlined">cancel</mat-icon>
         <span>Mark as cancelled</span>
         </button>
         <button mat-menu-item (click)="addAsMember(serviceQueryDetail[0])" *ngIf="serviceQueryDetail[0].enrollment_request_status == 3 &&  serviceQueryDetail[0].enrollment_request_status != 5">
         <mat-icon class="material-icons-outlined">person_add</mat-icon>
         <span> Add in enrolled members</span>
         </button>

         <button mat-menu-item (click)="deleteQuery(serviceQueryDetail[0])" *ngIf="(!serviceQueryDetail[0].customer_account_hash ||  serviceQueryDetail[0].customer_account_hash == 'null') && (isOwner)">
         <mat-icon class="material-icons-outlined">delete</mat-icon>
         <span> Delete query</span>
         </button> -->
                </mat-menu>
              </div>

              <div class="joining_list_flex">
                <div class="salon_img_member">
                  <img
                    [src]="serviceQueryDetail[0].profile_pic?.image_thumb_url"
                    onerror="this.src='../../../../../assets/images/user-avatar.svg'"
                    alt=""
                  />
                </div>
                <div class="hair_ct_heading">
                  <div class="rahul_headert">
                    <h4>{{ serviceQueryDetail[0].name }}</h4>
                    <p>
                      {{ serviceQueryDetail[0].country_code }}
                      {{ serviceQueryDetail[0].phone }}
                    </p>
                    <p>
                      {{
                        serviceQueryDetail[0]?.email &&
                        serviceQueryDetail[0]?.email != "" &&
                        serviceQueryDetail[0]?.email != "null"
                          ? serviceQueryDetail[0]?.email
                          : "No email added"
                      }}
                    </p>
                    <!-- <p>
                      {{
                        serviceQueryDetail[0].creation_time
                          | date : "MMM d, y, h:mm a" : "UTC"
                      }}
                    </p> -->
                  </div>
                </div>
              </div>

              <div class="joining_list">
                <p style="font-size: 12px; color: #888">
                  <span
                    class="joining_point"
                    [class.new-booking]="
                      serviceQueryDetail[0].status == 1
                    "
                    [class.under-process]="
                      serviceQueryDetail[0].status == 2
                    "
                    [class.completed]="
                      serviceQueryDetail[0].status == 3
                    "
                    
                  ></span>
                  <span class="joing_textd">
                    {{ serviceQueryDetail[0].item_status }}</span
                  >
                </p>
              </div>
            </div>
          </mat-card>
        </div>
        <div class="workout_timiing_open">
          <div class="booking_name_opop">
            <h1>Selected topic</h1>
          </div>
          <div class="solt_datef active_chip" style="padding-top: 5px">
            <mat-chip-list aria-label="service mode">
              <mat-chip selected color="primary">{{
                serviceQueryDetail[0].e_type
              }}</mat-chip>
            </mat-chip-list>
          </div>
        </div>

        <div class="right_deatils_pp">
          <!-- Opted services -->
          <div class="sub_ser">
            <h3 class="sub_headingt">Customer message:</h3>
            <div class="service_mode_chip">
              <div class="row">
                <p>{{ serviceQueryDetail[0].message }}</p>

                <span style="color: #888; font-size: 12px;">
                  {{
                    serviceQueryDetail[0].creation_time
                      | date : "MMM d, y, h:mm a" : "UTC"
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Notes -->
        <div
          class="trainer_start"
          *ngIf="
            serviceQueryDetail[0].reply && serviceQueryDetail[0].reply != 'null'
          "
        >
          <mat-card appearance="outlined">
            <div
              class="trainer_list bor_top"
              *ngIf="
                serviceQueryDetail[0].reply &&
                serviceQueryDetail[0].reply != 'null' &&
                serviceQueryDetail[0].reply != ''
              "
            >
              <div class="trainer_img">
                <img
                  [src]="serviceQueryDetail[0].entityInfo.default_thumb_image"
                  onerror="this.src='../../../../../assets/images/photo.png'"
                  alt=""
                />
              </div>
              <div class="trainer_heading">
                <h3>Your reply:</h3>
                <p class="date_rgt">
                  <!-- {{
                    serviceQueryDetail[0].entity_reply_date
                      | date : "MMM d, y, h:mm a"
                  }} -->
                {{
                    serviceQueryDetail[0].reply_date
                      | date : "MMM d, y, h:mm a" : "UTC"
                  }}
                </p>
                <p>{{ serviceQueryDetail[0].reply }}</p>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div class="col-sm-4 joining_interd">
        <div class="workout_timiing_open servicemode">
          <div class="booking_name_opop">
            <h1 style="margin-bottom: 0px !important">Service mode selected</h1>
          </div>
          <div class="solt_datef">
            <mat-chip-list aria-label="service mode">
              <mat-chip selected color="primary">{{
                serviceQueryDetail[0].s_mode
              }}</mat-chip>
            </mat-chip-list>
          </div>
        </div>

        <div class="booking_detail_info">
          <p>{{ serviceQueryDetail[0].entityInfo.name }}</p>
          <p class="address_frt">
            {{ serviceQueryDetail[0].entityInfo.address }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
